export default __webpack_public_path__ + "static/media/KuvikCatalogue2022.34bbcf8f.pdf";